import {
  dataInitialFilter,
  dataInitialConfigurableVariable
} from './state';

/**
 * Establecer datos para el modal del Formulario (registro y actualización).
 * 
 * @param {*} state 
 * @param {*} nextModalForm
 * @author Fernando CLaros Garcia
 */
export function setModalForm(state, nextModalForm) {
  state.modalForm = nextModalForm;
}

/**
 * Establecer datos iniciales para el filtro.
 * 
 * @param {*} state 
 * @author Fernando CLaros Garcia
 */
export function setFilter(state) {
  state.filter = dataInitialFilter();
}

/**
 * Establecer datos de las varibales configurables.
 * 
 * @param {*} state 
 * @param {*} nextPayload 
 * @author Fernando CLaros Garcia
 */
export function setConfigurableVariables(state, nextPayload) {
  state.configurableVariables = nextPayload;
}

/**
 * Establecer datos por defecto a la varibale configurable.
 * 
 * @param {*} state 
 * @author Fernando CLaros Garcia
 */
export function setDefaultConfigurableVariable(state) {
  state.configurableVariable = dataInitialConfigurableVariable();
}

/**
 * Establecer datos de las varibale configurable actual.
 * 
 * @param {*} state 
 * @param {*} nextPayload 
 * @author Fernando CLaros Garcia
 */
export function setConfigurableVariable(state, nextPayload) {
  state.configurableVariable = nextPayload;
}

/**
 * Establecer el valor por defecto del modelo.
 * 
 * @param {*} state 
 * @param {*} nextModel 
 * @author Fernando CLaros Garcia
 */
export function setModel(state, nextModel) {
  state.model = nextModel;
}

